import React, { useEffect, useState } from 'react';
import { Grid, Card, CardHeader, CardContent, Typography, Box, Divider } from '@mui/material';
import { AccessTime, CheckCircle, People } from '@mui/icons-material';
import { Chart } from 'react-chartjs-2';
import { getAllUser } from '../../api/user-api';
import UserAnalytics from '../UserAnalytics';
import UserBarChart from './UserAnalytics ';

const UserStats = ({ totalPendingUsers, totalApprovedUsers, totalUsers }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const userData = await getAllUser();
        setUsers(userData);
      } catch (error) {
        console.error("Error fetching users:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const cardStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 2,
    background: 'linear-gradient(135deg, #1e88e5 30%, #42a5f5 90%)',
    color: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
    },
  };

  const iconStyles = {
    fontSize: 50,
    marginBottom: '10px',
    color: '#fff',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3))',
  };

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {/* Card for Pending Users */}
      <Grid item xs={12} md={4}>
        <Card sx={cardStyles}>
          <AccessTime sx={iconStyles} />
          <Typography variant="h6" gutterBottom>
            Pending Users
          </Typography>
          <Divider sx={{ width: '50%', mb: 1, bgcolor: 'rgba(255, 255, 255, 0.5)' }} />
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {totalPendingUsers}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Users awaiting approval
          </Typography>
        </Card>
      </Grid>

      {/* Card for Approved Users */}
      <Grid item xs={12} md={4}>
        <Card sx={cardStyles}>
          <CheckCircle sx={iconStyles} />
          <Typography variant="h6" gutterBottom>
            Approved Users
          </Typography>
          <Divider sx={{ width: '50%', mb: 1, bgcolor: 'rgba(255, 255, 255, 0.5)' }} />
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {totalApprovedUsers}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Users who are approved
          </Typography>
        </Card>
      </Grid>

      {/* Card for Total Users */}
      <Grid item xs={12} md={4}>
        <Card sx={cardStyles}>
          <People sx={iconStyles} />
          <Typography variant="h6" gutterBottom>
            Total Users
          </Typography>
          <Divider sx={{ width: '50%', mb: 1, bgcolor: 'rgba(255, 255, 255, 0.5)' }} />
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {totalUsers}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Total number of users
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        {/* User Analytics Chart */}
        <UserBarChart
          totalPendingUsers={totalPendingUsers}
          totalApprovedUsers={totalApprovedUsers}
          totalUsers={totalUsers}
        />
      </Grid>
      {/* User Analytics Component */}
      <Grid item xs={12} md={6}>
        <UserAnalytics users={users} />
      </Grid>
    </Grid>
  );
};

export default UserStats;
